export default __webpack_public_path__ + "static/media/clay-banks-e6pK_snssSY-unsplash.4cdc9edd.png";